import {
  CANCEL_SCHEDULE,
  CANCEL_SUBSCRIPTION,
  CHECK_PLAN_LIMIT,
  CLEAR_COUPON_CODE_STATUS,
  DOWNGRADE_PLAN,
  GET_ESTIMATION_DETAILS,
  GET_PLANS_LIST,
  RESET_RESPONSE_STATUS,
  SET_CANCEL_SCHEDULE,
  SET_CANCEL_SUBSCRIPTION,
  SET_DOWNGRADE_PLAN,
  SET_ESTIMATION_DETAILS,
  SET_PLAN_LIMIT,
  SET_PLANS_LIST,
  SET_SHOW_ESTIMATION_SCREEN,
  SET_UPGRADE_PLAN,
  UPGRADE_PLAN
} from "./actionTypes"

const initialState = {
  planDetails: { loading: false },
  showEstimationScreen: false,
  type: null,
  cancelSubscription: {
    loading: false
  },
  planLimit: {
    loading: false
  },
  estimationScreenDetails: {
    loading: false,
    couponLoading: false
  },
  upgradePlan: {
    loading: false
  },
  downgradePlan: {
    loading: false

  },
  cancelSchedule: {
    loading: false
  }
}

const Pricing = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLANS_LIST:
      state = {
        ...state,
        planDetails: { loading: true }
      }
      break
    case SET_PLANS_LIST:
      state = {
        ...state,
        planDetails: {
          ...state.planDetails,
          loading: false,
          ...action.payload.response,
          ...action.payload
        }
      }
      break
    case SET_SHOW_ESTIMATION_SCREEN:
      state = {
        ...state,
        showEstimationScreen: action?.payload?.show,
        type: action?.payload?.type,
        planId: action?.payload?.planId,
        active_trial: action?.payload?.active_trial || false
      }
      break
    case CANCEL_SUBSCRIPTION:
      state = {
        ...state,
        cancelSubscription: {
          loading: true
        }
      }
      break
    case SET_CANCEL_SUBSCRIPTION:
      state = {
        ...state,
        cancelSubscription: {
          loading: false,
          ...action.payload
        }
      }
      break
    case CHECK_PLAN_LIMIT:
      state = {
        ...state,
        planLimit: {
          loading: true,
          planId: action.payload?.plan
        }
      }
      break
    case SET_PLAN_LIMIT:
      state = {
        ...state,
        planLimit: {
          loading: false,
          ...action.payload

        }
      }
      break
    case GET_ESTIMATION_DETAILS:
      state = {
        ...state,
        estimationScreenDetails: action?.payload?.from === "coupon" ? { ...state.estimationScreenDetails, couponLoading: true } : { loading: true }
      }
      break
    case SET_ESTIMATION_DETAILS:
      state = {
        ...state,
        estimationScreenDetails: {
          loading: false,
          couponLoading: false,
          ...action.payload

        }
      }
      break
    case UPGRADE_PLAN:
      state = {
        ...state,
        upgradePlan: {
          loading: true,

        }
      }
      break
    case SET_UPGRADE_PLAN:
      state = {
        ...state,
        upgradePlan: {
          loading: false,
          ...action.payload

        },
        planDetails: {
          ...state.planDetails,
          currentPlan: action.payload?.responseCode ? action.payload?.plan_id : state.planDetails.currentPlan

        },
      }
      break
    case RESET_RESPONSE_STATUS:
      state = {
        ...state,
        upgradePlan: {
          loading: false,

        },
        cancelSubscription: {
          loading: false
        },
        downgradePlan: {
          loading: false
        },
        planLimit: {
          loading: false
        },
        cancelSchedule: {
          loading: false
        },
        estimationScreenDetails: action.payload?.from === "estimation" ? { loading: false } : { ...state.estimationScreenDetails }

      }
      break
    case DOWNGRADE_PLAN:
      state = {
        ...state,
        downgradePlan: {
          loading: true,

        }
      }
      break
    case SET_DOWNGRADE_PLAN:
      state = {
        ...state,
        downgradePlan: {
          loading: false,
          ...action.payload

        },
      }
      break
    case CANCEL_SCHEDULE:
      state = {
        ...state,
        cancelSchedule: {
          loading: true,

        }
      }
      break
    case SET_CANCEL_SCHEDULE:
      state = {
        ...state,
        cancelSchedule: {
          loading: false,
          method: action?.payload?.method,
          ...action.payload
        }
      }
      break
    case CLEAR_COUPON_CODE_STATUS:
      state = {
        ...state,
        estimationScreenDetails: {
          ...state.estimationScreenDetails,
          response: {
            ...state.estimationScreenDetails?.response,
            couponValid: null,
            discount: null,

          }

        },
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Pricing
